import { createSlice } from '@reduxjs/toolkit';
import { ChannelType } from '@src/types/campaign';
import { getInfluencerListThunk } from '@src/views/project/store/influencerThunk';
import { createInfluencerThunk } from './projectThunk';
import { Country } from '../data/countryEnum';
import { InfluencerData } from '../types';

interface InfluencerRawData {
  이메일: string;
  캠페인신청ID: string;
  캠페인이벤트ID: string;
  UID: string;
  캠페인ID: string;
  진행상태: string;
  브랜드: string;
  캠페인명: string;
  신청자: string;
  '국가 (사용자)': string;
  'Instagram URL'?: string;
  'Instagram Username'?: string;
  'Instagram Follow #'?: number;
  'Youtube URL'?: string;
  'Youtube Channel Name'?: string;
  'Youtube Follow #'?: number;
  'Facebook URL'?: string;
  'Facebook Username'?: string;
  'Facebook Follow #'?: number;
  'Tiktok URL'?: string;
  'Tiktok Username'?: string;
  'Tiktok Follow #'?: number;
}

enum ApprovedCase {
  '승인' = 'true',
  '배송준비중' = 'true',
  '배송중' = 'true',
  '배송완료' = 'true',
  '신청' = 'false',
  '거절됨' = 'false',
  '취소됨' = 'false',
}

interface InfluencerMatchingState {
  influencers: InfluencerData[];
}

const InfluencerMatchingInitialState: InfluencerMatchingState = {
  influencers: [],
};

const InfluencerMatchingSlice = createSlice({
  name: 'influencerMatching',
  initialState: InfluencerMatchingInitialState,
  reducers: {
    onChangeInfluencerData: (state, { payload }) => {
      const tmpChannelType =
        payload.channelType.charAt(0).toUpperCase() +
        payload.channelType.slice(1);

      const tmpInfluencer = payload.influencerList
        .filter(
          (element: InfluencerRawData) =>
            element[`${tmpChannelType} URL`] !== ''
        )
        .map((element: InfluencerRawData) => {
          const { 신청자, UID } = element;
          const _channelName =
            tmpChannelType === 'Youtube'
              ? 'Youtube Channel Name'
              : `${tmpChannelType} Username`;

          return {
            charisUserId: UID,
            influencerName: 신청자,
            charisSaId: element['캠페인신청ID'],
            country: Country[element['국가 (사용자)']],
            approved: ApprovedCase[element['진행상태']],
            accountName: element[_channelName],
            accountUrl: element[`${tmpChannelType} URL`],
            follower: element[`${tmpChannelType} Follow #`],
          };
        });

      state.influencers = tmpInfluencer;
    },

    onDeleteUser: (state, { payload }) => {
      state.influencers = payload;
    },
  },
  extraReducers: ({ addCase }) => {
    addCase(createInfluencerThunk.fulfilled, () => {});

    addCase(getInfluencerListThunk.fulfilled, (state, { payload }) => {
      const tmpData = payload.data.map(
        (element: {
          accountName: string;
          accountUrl: string;
          approved: boolean;
          projectId: string;
          channelType: ChannelType;
          charisSaId: string;
          charisUserId: string;
          country: string;
          follower: number;
          id: string;
          influencerName: string;
        }) => {
          return {
            charisUserId: element.charisUserId,
            influencerName: element.influencerName,
            charisSaId: element.charisSaId,
            country: element.country,
            approved: element.approved,
            accountName: element.accountName,
            accountUrl: element.accountUrl,
            follower: element.follower,
          };
        }
      );

      state.influencers = tmpData;
    });
  },
});

export const { onChangeInfluencerData, onDeleteUser } =
  InfluencerMatchingSlice.actions;

export default InfluencerMatchingSlice.reducer;
